<template>
  <!-- 能源类型 -->
  <span class="apphome">
    <div class="apphome_box">
      <div style="margin-bottom:12px;display:flex;justify-content: space-between;">
        <div class="left1" style="display:flex;align-items: center;width:60%">
          <el-input placeholder="请输入菜单名称" v-model="searchName" style="width:35%"></el-input>
          <el-button type="primary" icon="el-icon-search" style="margin:0 20px" @click="search_fn" plain>搜索</el-button>
          <el-button type="primary" @click="addMenu" style="margin-right:40px">新增顶级菜单<i
              class="el-icon-document-add"></i></el-button>
        </div>
        <!-- <el-alert title="需要配置请致电12597563241"  type="info" show-icon></el-alert> -->
        <div class="telephone">
          <i class="el-alert__icon el-icon-info"></i>
          <span>需要配置请致电 12597563241</span>
        </div>
      </div>
      <el-table id="demo" max-height="750" highlight-current-row
        :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa'}"
        stripe :data="tableData" border style="width: 100%" row-key="id"
        :tree-props="{children: 'next', hasChildren: 'hasChildren'}">
        <el-table-column type="index" label="#" width="50" align="center">
        </el-table-column>
        <el-table-column label="名称" align="left" min-width="150">

          <template slot-scope="{row}">
            <el-link type="primary" :class="{'actived':mainId===row.id}" @click="tempclick(row)">{{ row.rightname }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="图形文件" align="center" min-width="150">
          <template slot-scope="{row}">
            <img v-if="row.iconFile" :src="'./static/image/科技蓝/menu/'+row.iconFile + '.png'" class="avatar"
              style="position: relative;left: 50%;transform: translateX(-50%);">
          </template>
        </el-table-column>
        <el-table-column label="路由" align="center" width="200">
          <template slot-scope="{row}">
            {{ row.webpage || '模块' }}
          </template>
        </el-table-column>
        <el-table-column label="描述" align="center" min-width="150">
          <template slot-scope="{row}">
            {{ row.memo }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="500">
          <template #default="{row}">

            <span class="buttoned_box">
              <el-button type="text" @click="addMenuChild(row)" style="color:#409eff;font-weight: bold">添加子级菜单
              </el-button>
              <span class="line"></span>
              <el-button type="text" @click="editMenu(row)" style="color:#409eff;font-weight: bold">编辑</el-button>
              <span class="line"></span>
              <el-popconfirm title="这是一段内容确定删除吗？" @onConfirm="deleteMenu(row)">
                <template #reference>
                  <el-button type="text" style="color:#FF7765;font-weight: bold">删除</el-button>
                </template>
              </el-popconfirm>
            </span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增修改 -->
      <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false' :visible.sync="dialogVisible"
        width="400" center>
        <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
          <!-- <span style="font-size:18px">已选中菜单（{{deviceName}}）</span> -->
          <el-form-item label="菜单名称:" prop="rightname">
            <el-input v-model="temp.rightname"></el-input>
          </el-form-item>
          <el-form-item label="菜单路径:" prop="webpage">
            <el-input v-model="temp.webpage"></el-input>
          </el-form-item>

          <el-form-item label="图形文件:" prop="iconFile">
            <el-upload class="avatar-uploader" action="http://localhost:8080/" :show-file-list="false"
              :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否有子菜单:" prop="hasSonMenu">
            <el-radio v-model="radioValue" label="0">无</el-radio>
            <el-radio v-model="radioValue" label="1">有</el-radio>
          </el-form-item>
          <el-form-item label="描述:" prop="memo">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"
              v-model="temp.memo"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

    </div>
  </span>
</template>
<script>

  //  import {} from "../../api/energySubType";
  import menuApi from '@/components/api/menuApi.js'
  import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
  import userManagerStore from '@/page/userManager/userManagerStore.js'
  export default {
    components: {
      nomalInputDialog,
    },
    data () {
      return {
        searchName: "",
        imageUrl: '',
        imgIconFile: "",
        radioValue: "0",
        tableData: [],
        tableDataCopy: [],
        NowUnit: {},
        mainId: "",
        nowMenu: "",
        deviceName: "",
        temp: {},
        dialogVisible: false,
        dialogStatus: 'add',
        textMap: {
          add: "新增web顶级菜单",
          addSon: "新增子级菜单",
          edit: "修改web菜单"
        },
        rules: {
          rightname: [
            {required: true,message: '请输入菜单名称',trigger: 'blur'}
          ],


        },
      };
    },
    computed: {


    },
    watch: {
      dialogVisible (val) {
        if(!val) {
          this.imageUrl=''
          this.imgIconFile=""
        }
      },
      searchName (val) {
        if(val=='') {
          this.tableData=this.tableDataCopy
        }
      },
    },
    mounted () {
      this.NowUnit=this.$store.unitStore.getters.getNowUnit
      this.getList();//获取列表数据 

    },
    methods: {
      // handleAvatarSuccess(res, file) {
      //   this.imageUrl = URL.createObjectURL(file.raw);
      // },
      //图片选择
      beforeAvatarUpload (file) {
        const isJPG=file.type==='image/jpeg';
        const isLt2M=file.size/1024/1024<2;
        var fileName=file.name
        this.imgIconFile=fileName.slice(0,fileName.length-4)
        this.imageUrl="./static/image/科技蓝/menu/"+file.name

        return isJPG&&isLt2M;
      },
      //搜索列表
      search_fn () {
        // this.tableData = []
        var data=JSON.parse(JSON.stringify(this.tableDataCopy))
        var arr=[]
        var searchName=this.searchName
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.next.length!=0) {
                if(row.rightname.includes(searchName)) {
                  arr.push(row)
                }
                getStr(row.next)
              } else {

                if(row.rightname.includes(searchName)) {
                  arr.push(row)
                }

              }
            })
          }
          getStr(data)
        }
        recursiveFunction()
        arr.forEach(item => item.next=[])
        this.tableData=arr
      },
      //弹出绑定设备
      tempclick (v) {
        this.mainId=v.id;
        this.nowMenu=v
        this.deviceName=v.rightname
        // this.getDevice()
        // if (this.$refs.child) {
        //   this.$refs.child.childMethod(this.mainId);
        // }
      },
      //添加顶级菜单（新）
      addMenu () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {

            if(this.dialogStatus=='add') {
              this.$api.menuApi.saveMenuAdd(this.temp.rightname,"menuright",'1',this.temp.webpage,"1","1",this.radioValue,this.imgIconFile,this.temp.memo,respon => {
                // this.$dialogMethod.showMessage("添加成功!")

                this.$message({message: "添加成功",type: 'success'});
                //刷新页面
                this.getList()
                this.dialogVisible=false
              },respon => {
                this.$message({message: respon,type: 'error'});
              })
            } else {
              var parentid=this.nowMenu.id //当前选中web菜单的id
              var serialno=this.nowMenu.serialno+1
              // this.$api.menuApi.saveMenu("", item.rightname,

              this.$api.menuApi.saveMenuSon(this.temp.rightname,
                "menuright",serialno,this.temp.webpage,parentid,"1","1",this.radioValue,this.imgIconFile,this.temp.memo,respon => {
                  // console.log("respon",respon);

                  // this.$dialogMethod.showMessage("添加成功!")
                  this.$message({message: "添加成功",type: 'success'});
                  //刷新页面
                  this.getList()
                  this.dialogVisible=false
                },respon => {
                  // console.log("respon",respon);
                  this.$message({message: respon,type: 'error'});
                })
            }

          } else {
            return false;
          }
        });
      },
      //添加顶级菜单（旧）
      // addMenu() {
      // 	if(this.nowMenu == "") {
      // 		this.$dialogMethod.showMessage("请先选同级菜单!")
      // 		return
      // 	}
      // 	var parentid = "" //当前选中web菜单的父级id
      // 	if(undefined != this.nowMenu.parentid) {
      // 		parentid = this.nowMenu.parentid
      // 	}
      // 	var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
      // 	dialog.open('添加web菜单', [{
      // 		name: '菜单名称',
      // 		pkid: 'rightname'
      // 	}, {
      // 		name: '菜单路径',
      // 		pkid: 'webpage'
      // 	}], item => {
      // 		if(item.rightname == undefined){
      // 			this.$message({ showClose: true, message: '请输入菜单名称', type: 'warning'});
      // 			return
      // 		}
      // 		//添加接口
      // 		//var serialno = isempty(this.nextItem) ? this.nowMenu.serialno + 1 : (this.nowMenu.serialno + this.nextItem.serialno) / 2
      // 		var serialno = this.nowMenu.serialno + 1
      // 		this.$api.menuApi.saveMenuAdd(item.rightname, "menuright", serialno, item.webpage, parentid,"1","1", respon => {
      // 			// this.$dialogMethod.showMessage("添加成功!")
      // 			 this.$message({message:"添加成功" ,type: 'success'});
      // 			//刷新页面
      // 			this.getList()
      // 		}, respon => {
      // 			err(respon)
      // 		})
      // 	})
      // },
      //添加子菜单
      addMenuChild (nowMenu) {
        this.dialogStatus='addSon';
        if(nowMenu.hasSonMenu==0) {
          this.$message({message: '请先把 '+nowMenu.rightname+' 修改成有子菜单',type: 'warning'});
          return
        }
        this.dialogVisible=true;
        this.nowMenu=nowMenu
        this.textMap.addSon='新增子级菜单（'+nowMenu.rightname+'）'
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={};

      },
      //修改
      editMenu (v) {
        this.dialogStatus='edit';
        this.dialogVisible=true;
        this.nowMenu=v
        this.radioValue=v.hasSonMenu.toFixed(0)
        this.imgIconFile=v.iconFile
        if(v.iconFile) {
          this.imageUrl="./static/image/科技蓝/menu/"+v.iconFile+".png"
        } else {
          this.imageUrl=""
        }

        this.temp=Object.assign({},v);
        //  this.textMap.edit = '修改web菜单（'+v.rightname+'）'
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });


      },
      //确定修改
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            //修改接口
            this.$api.menuApi.saveMenu(this.nowMenu.id,this.temp.rightname,
              this.nowMenu.righttype,this.nowMenu.serialno,this.temp.webpage,this.nowMenu.parentid,"1","1",this.radioValue,this.imgIconFile,this.temp.memo,respon => {
                // this.$dialogMethod.showMessage("修改成功!")
                this.$message({message: "修改成功",type: 'success'});
                //刷新页面
                this.getList()
                this.dialogVisible=false;
                this.$store.menuStore.commit("getMenuList")
              },respon => {
                err(respon)
                this.$message({message: respon,type: 'error'});
              })
          } else {
            return false;
          }
        });

      },
      //删除
      deleteMenu (nowMenu) {
        var id=nowMenu.id //当前选中web菜单的id
        //删除接口
        this.$api.menuApi.deleteMenuById(id,respon => {
          // this.$dialogMethod.showMessage(respon)
          this.$message({message: respon,type: 'success'});
          // this.nowMenu = undefined
          this.getList()
          this.$store.menuStore.commit("getMenuList")
        },respon => {
          err(respon)
          this.$message({message: respon,type: 'error'});
        })

      },

      //获取列表数据
      getList () {
        var res={
          "pcmDefault": [],
          "appRight": [
            {
              "next": [],
              "rightname": "首页",
              "visible": 1,
              "formclass": null,
              "iconFile": "/pf3_2.png;/pf3_7.png",
              "memo": null,
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 1,
              "righttype": "appright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": null,
              "rightid": "244c74932cf5405483994991d8247b02",
              "hasSonMenu": 0,
              "id": "244c74932cf5405483994991d8247b02",
              "webiconcssclass": null,
              "webpage": "customize_page",
              "isPage": 0
            },
            {
              "next": [],
              "rightname": "设备监测",
              "visible": 1,
              "formclass": null,
              "iconFile": "",
              "memo": "",
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 2,
              "righttype": "appright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": "",
              "rightid": "5345ab86d7eb4c868af6049354fc1774",
              "hasSonMenu": 0,
              "id": "5345ab86d7eb4c868af6049354fc1774",
              "webiconcssclass": null,
              "webpage": "",
              "isPage": 0
            },
            {
              "next": [],
              "rightname": "预警监测",
              "visible": 1,
              "formclass": null,
              "iconFile": "",
              "memo": "",
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 3,
              "righttype": "appright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": "",
              "rightid": "bffdb7964ddb45508916b4f57921e666",
              "hasSonMenu": 0,
              "id": "bffdb7964ddb45508916b4f57921e666",
              "webiconcssclass": null,
              "webpage": "",
              "isPage": 0
            },
            {
              "next": [],
              "rightname": "事件管理",
              "visible": 1,
              "formclass": null,
              "iconFile": "",
              "memo": "",
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 4,
              "righttype": "appright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": "",
              "rightid": "7edab01e682e40d2b371c79928d8ea12",
              "hasSonMenu": 0,
              "id": "7edab01e682e40d2b371c79928d8ea12",
              "webiconcssclass": null,
              "webpage": "",
              "isPage": 0
            },
            {
              "next": [
                {
                  "next": [],
                  "rightname": "个人资料",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "56350C642ECF40D6839BE3DCC49D1588",
                  "serialno": 1,
                  "righttype": "appright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "97e7558684104ab68fe93f981f3ddb85",
                  "hasSonMenu": 0,
                  "id": "97e7558684104ab68fe93f981f3ddb85",
                  "webiconcssclass": null,
                  "webpage": "personage_datum",
                  "isPage": 0
                },
                {
                  "next": [],
                  "rightname": "修改密码",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "56350C642ECF40D6839BE3DCC49D1588",
                  "serialno": 2,
                  "righttype": "appright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "777bca08206f4e8f953c82c85a3f1a73",
                  "hasSonMenu": 0,
                  "id": "777bca08206f4e8f953c82c85a3f1a73",
                  "webiconcssclass": null,
                  "webpage": "modification_pwd",
                  "isPage": 0
                },
                {
                  "next": [],
                  "rightname": "清除缓存",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "56350C642ECF40D6839BE3DCC49D1588",
                  "serialno": 3,
                  "righttype": "appright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "a4990ac9cdd84e2788085b537a61885a",
                  "hasSonMenu": 0,
                  "id": "a4990ac9cdd84e2788085b537a61885a",
                  "webiconcssclass": null,
                  "webpage": "clearcache",
                  "isPage": 0
                },
                {
                  "next": [],
                  "rightname": "切换账号",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "56350C642ECF40D6839BE3DCC49D1588",
                  "serialno": 4,
                  "righttype": "appright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "249a0285dc55454f8db82bfb82b48950",
                  "hasSonMenu": 0,
                  "id": "249a0285dc55454f8db82bfb82b48950",
                  "webiconcssclass": null,
                  "webpage": "logout",
                  "isPage": 0
                },
                {
                  "next": [],
                  "rightname": "修改连接",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "56350c642ecf40d6839be3dcc49d1588",
                  "serialno": 5,
                  "righttype": "appright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "2c7108ee3b584494934e5620245d33d1",
                  "hasSonMenu": 0,
                  "id": "2c7108ee3b584494934e5620245d33d1",
                  "webiconcssclass": null,
                  "webpage": "switchoverip",
                  "isPage": 0
                }
              ],
              "rightname": "系统管理",
              "visible": 1,
              "formclass": null,
              "iconFile": "",
              "memo": "",
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 5,
              "righttype": "appright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": "",
              "rightid": "56350c642ecf40d6839be3dcc49d1588",
              "hasSonMenu": 0,
              "id": "56350c642ecf40d6839be3dcc49d1588",
              "webiconcssclass": null,
              "webpage": "",
              "isPage": 0
            }
          ],
          "miniRight": [],
          "menuRight": [
            {
              "next": [],
              "rightname": "单位分布",
              "visible": 1,
              "formclass": null,
              "iconFile": "menu.btn光伏系统",
              "memo": null,
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 1,
              "righttype": "menuright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": null,
              "rightid": "6a2a3d204b9d4459850159f715373e30",
              "hasSonMenu": 0,
              "id": "6a2a3d204b9d4459850159f715373e30",
              "webiconcssclass": null,
              "webpage": "/webMap",
              "isPage": 0
            },
            {
              "next": [],
              "rightname": "工况图",
              "visible": 1,
              "formclass": null,
              "iconFile": null,
              "memo": null,
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 2,
              "righttype": "menuright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": null,
              "rightid": "0b7ca836c0214e4c85b8d913d76e94c6",
              "hasSonMenu": 0,
              "id": "0b7ca836c0214e4c85b8d913d76e94c6",
              "webiconcssclass": null,
              "webpage": null,
              "isPage": 0
            },
            {
              "next": [],
              "rightname": "预警监测",
              "visible": 1,
              "formclass": null,
              "iconFile": "",
              "memo": "",
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 3,
              "righttype": "menuright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": "",
              "rightid": "d466c5bbabf046119431992f6c91d79d",
              "hasSonMenu": 0,
              "id": "d466c5bbabf046119431992f6c91d79d",
              "webiconcssclass": null,
              "webpage": "",
              "isPage": 0
            },
            {
              "next": [],
              "rightname": "设备监测",
              "visible": 1,
              "formclass": null,
              "iconFile": "",
              "memo": "",
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 4,
              "righttype": "menuright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": "",
              "rightid": "54286d5099f3460192e202d1c13add29",
              "hasSonMenu": 0,
              "id": "54286d5099f3460192e202d1c13add29",
              "webiconcssclass": null,
              "webpage": "",
              "isPage": 0
            },
            {
              "next": [
                {
                  "next": [
                    {
                      "next": [],
                      "rightname": "实时列表",
                      "visible": 1,
                      "formclass": null,
                      "iconFile": null,
                      "memo": null,
                      "rightcode": null,
                      "showdialog": null,
                      "pagePath": null,
                      "title": null,
                      "parentid": "cda2c0429f864ed58026770a4207bbd6",
                      "serialno": 1,
                      "righttype": "menuright",
                      "library": null,
                      "createTime": null,
                      "enable": 1,
                      "entityName": "PcmRight",
                      "pageFile": null,
                      "rightid": "92c15f0a4efd4408a4ddfe5c85417ab4",
                      "hasSonMenu": 0,
                      "id": "92c15f0a4efd4408a4ddfe5c85417ab4",
                      "webiconcssclass": null,
                      "webpage": "/virtualDeviceRTValue",
                      "isPage": 0
                    },
                    {
                      "next": [],
                      "rightname": "实时曲线",
                      "visible": 1,
                      "formclass": null,
                      "iconFile": null,
                      "memo": null,
                      "rightcode": null,
                      "showdialog": null,
                      "pagePath": null,
                      "title": null,
                      "parentid": "cda2c0429f864ed58026770a4207bbd6",
                      "serialno": 2,
                      "righttype": "menuright",
                      "library": null,
                      "createTime": null,
                      "enable": 1,
                      "entityName": "PcmRight",
                      "pageFile": null,
                      "rightid": "d3d84fcb48ef4075a36a998068b6098c",
                      "hasSonMenu": 0,
                      "id": "d3d84fcb48ef4075a36a998068b6098c",
                      "webiconcssclass": null,
                      "webpage": "/virtualDeviceRTCurve",
                      "isPage": 0
                    }
                  ],
                  "rightname": "实时数据",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": "menu.btn抄表系统",
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "9078048d7fca4dcd84fc5ceb9f50358b",
                  "serialno": 5,
                  "righttype": "menuright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "cda2c0429f864ed58026770a4207bbd6",
                  "hasSonMenu": 1,
                  "id": "cda2c0429f864ed58026770a4207bbd6",
                  "webiconcssclass": null,
                  "webpage": null,
                  "isPage": 0
                },
                {
                  "next": [
                    {
                      "next": [],
                      "rightname": "历史列表",
                      "visible": 1,
                      "formclass": null,
                      "iconFile": null,
                      "memo": null,
                      "rightcode": null,
                      "showdialog": null,
                      "pagePath": null,
                      "title": null,
                      "parentid": "BD618317DE614FC6878D993FFEC9E4C8",
                      "serialno": 1,
                      "righttype": "menuright",
                      "library": null,
                      "createTime": null,
                      "enable": 1,
                      "entityName": "PcmRight",
                      "pageFile": null,
                      "rightid": "9080872171534441bdafe5157e5e04ee",
                      "hasSonMenu": 0,
                      "id": "9080872171534441bdafe5157e5e04ee",
                      "webiconcssclass": null,
                      "webpage": "/historyValue",
                      "isPage": 0
                    },
                    {
                      "next": [],
                      "rightname": "历史曲线",
                      "visible": 1,
                      "formclass": null,
                      "iconFile": null,
                      "memo": null,
                      "rightcode": null,
                      "showdialog": null,
                      "pagePath": null,
                      "title": null,
                      "parentid": "BD618317DE614FC6878D993FFEC9E4C8",
                      "serialno": 2,
                      "righttype": "menuright",
                      "library": null,
                      "createTime": null,
                      "enable": 1,
                      "entityName": "PcmRight",
                      "pageFile": null,
                      "rightid": "ccbfffbf099e4d15a89213fc772970c3",
                      "hasSonMenu": 0,
                      "id": "ccbfffbf099e4d15a89213fc772970c3",
                      "webiconcssclass": null,
                      "webpage": "/historyCurve",
                      "isPage": 0
                    }
                  ],
                  "rightname": "历史数据",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": "menu.btn03",
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "9078048d7fca4dcd84fc5ceb9f50358b",
                  "serialno": 6,
                  "righttype": "menuright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "bd618317de614fc6878d993ffec9e4c8",
                  "hasSonMenu": 1,
                  "id": "bd618317de614fc6878d993ffec9e4c8",
                  "webiconcssclass": null,
                  "webpage": null,
                  "isPage": 0
                }
              ],
              "rightname": "数据查询",
              "visible": 1,
              "formclass": null,
              "iconFile": "menu.btn异常监测y",
              "memo": null,
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 5,
              "righttype": "menuright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": null,
              "rightid": "9078048d7fca4dcd84fc5ceb9f50358b",
              "hasSonMenu": 1,
              "id": "9078048d7fca4dcd84fc5ceb9f50358b",
              "webiconcssclass": null,
              "webpage": null,
              "isPage": 0
            },
            {
              "next": [
                {
                  "next": [],
                  "rightname": "设备管理",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "D210250E9BD44F33AF2E45FABBB55D4A",
                  "serialno": 1,
                  "righttype": "menuright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "efa4f0326a714fb89e8b2fc322277a41",
                  "hasSonMenu": 0,
                  "id": "efa4f0326a714fb89e8b2fc322277a41",
                  "webiconcssclass": null,
                  "webpage": "/archives",
                  "isPage": 0
                },
                {
                  "next": [],
                  "rightname": "设备定义",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "D210250E9BD44F33AF2E45FABBB55D4A",
                  "serialno": 2,
                  "righttype": "menuright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "8be0f58a2c3a4ea6bc30e630a18c9119",
                  "hasSonMenu": 0,
                  "id": "8be0f58a2c3a4ea6bc30e630a18c9119",
                  "webiconcssclass": null,
                  "webpage": "/archivesType",
                  "isPage": 0
                },
                {
                  "next": [],
                  "rightname": "字典定义",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "D210250E9BD44F33AF2E45FABBB55D4A",
                  "serialno": 3,
                  "righttype": "menuright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "2dd96432106c40ab89aab97886a4d13d",
                  "hasSonMenu": 0,
                  "id": "2dd96432106c40ab89aab97886a4d13d",
                  "webiconcssclass": null,
                  "webpage": "/enumSetting",
                  "isPage": 0
                },
                {
                  "next": [],
                  "rightname": "设备绑定",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "D210250E9BD44F33AF2E45FABBB55D4A",
                  "serialno": 4,
                  "righttype": "menuright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "874b7bb792fd4dcaa14ccceb37c12e06",
                  "hasSonMenu": 0,
                  "id": "874b7bb792fd4dcaa14ccceb37c12e06",
                  "webiconcssclass": null,
                  "webpage": "/bindArchives",
                  "isPage": 0
                }
              ],
              "rightname": "设备管理",
              "visible": 1,
              "formclass": null,
              "iconFile": "menu.btn管理工具",
              "memo": null,
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 6,
              "righttype": "menuright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": null,
              "rightid": "d210250e9bd44f33af2e45fabbb55d4a",
              "hasSonMenu": 1,
              "id": "d210250e9bd44f33af2e45fabbb55d4a",
              "webiconcssclass": null,
              "webpage": null,
              "isPage": 0
            },
            {
              "next": [
                {
                  "next": [],
                  "rightname": "历史事件",
                  "visible": 1,
                  "formclass": null,
                  "iconFile": null,
                  "memo": null,
                  "rightcode": null,
                  "showdialog": null,
                  "pagePath": null,
                  "title": null,
                  "parentid": "B05497A59BB54240922C911E38CBD0B5",
                  "serialno": 1,
                  "righttype": "menuright",
                  "library": null,
                  "createTime": null,
                  "enable": 1,
                  "entityName": "PcmRight",
                  "pageFile": null,
                  "rightid": "fe719cab25a54bdc84148518168e898c",
                  "hasSonMenu": 0,
                  "id": "fe719cab25a54bdc84148518168e898c",
                  "webiconcssclass": null,
                  "webpage": "/events",
                  "isPage": 0
                }
              ],
              "rightname": "事件管理",
              "visible": 1,
              "formclass": null,
              "iconFile": "menu.btn异常监测",
              "memo": null,
              "rightcode": null,
              "showdialog": null,
              "pagePath": null,
              "title": null,
              "parentid": null,
              "serialno": 7,
              "righttype": "menuright",
              "library": null,
              "createTime": null,
              "enable": 1,
              "entityName": "PcmRight",
              "pageFile": null,
              "rightid": "b05497a59bb54240922c911e38cbd0b5",
              "hasSonMenu": 1,
              "id": "b05497a59bb54240922c911e38cbd0b5",
              "webiconcssclass": null,
              "webpage": null,
              "isPage": 0
            }
          ]
        };
        this.tableData=res.menuRight
        this.tableDataCopy=res.menuRight
        userManagerStore.commit('getAllRightCopy',this.$store.userStore.state.nowUserInfo.userId)
        // menuApi.getMenu("menuright", true, respon => {
        // 			this.tableData = respon
        // })




      },


    }
  };
</script>
<style lang="scss">
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .telephone {
    width: 2.6rem;
    height: 40px;
    background-color: #f4f4f5;
    display: flex;
    align-items: center;
    border-radius: 5px;
    color: #909399;

    i {
      margin-left: 20px;
      margin-right: 10px;
    }
  }

  .buttoned_box {
    display: flex;
    // justify-content: space-around;
    justify-content: center;
    align-items: center;

    .line {
      display: inline-block;
      width: 1px;
      height: 20px;
      background-color: #E6E6E6;
      margin: 0px 20px;
    }

    .buttoned {
      cursor: pointer;
    }

    /deep/.el-button span {
      font-size: 15px;
    }
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    min-width: 50px;
    height: 150px;
    min-height: 50px;
    display: block;
  }

  .select_tree {
    .el-tree-node {
      .is-leaf+.el-checkbox .el-checkbox__inner {
        display: inline-block;
      }

      .el-checkbox__input>.el-checkbox__inner {
        display: none;
      }
    }

  }
</style>
<style lang="scss" scoped>
  .apphome {
    padding: 15px;
  }

  .actived {
    color: red;
  }

  .apphome_box {
    background-color: #fff;
    padding: 20px;
    min-height: calc(100vh - 160px);
    max-height: calc(100vh - 160px);
    position: relative;
  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>